import { useLanguage } from "../../hooks/useLanguage"
import { ArrowUpRight } from "../icons"

export default function About() {
  const { t } = useLanguage()
  const a = t.about
  const info = t.contactInfo

  return (
    <section id="sobre" className="gms-wrap pt-section">
      <div className="flex flex-wrap items-stretch gap-x-[72px] gap-y-12">
        <div className="flex min-w-0 flex-[1.3_1_520px] flex-col">
          <div className="gms-eyebrow">{a.eyebrow}</div>
          <h2 className="gms-h2">{a.title}</h2>
          <p className="mt-6 max-w-[600px] text-[17px] leading-[1.6] text-gms-muted">{a.lead}</p>
          <div className="mt-auto grid gap-6 pt-10 [grid-template-columns:repeat(auto-fit,minmax(min(200px,100%),1fr))]">
            {a.principles.map(({ title, text }) => (
              <div key={title} className="border-t-2 border-gms-ink pt-[18px]">
                <h3 className="text-[18px] font-semibold tracking-[-0.02em]">{title}</h3>
                <p className="mt-2 text-[16px] leading-[1.5] text-gms-muted">{text}</p>
              </div>
            ))}
          </div>
        </div>

        <aside aria-label={a.founderLabel} className="flex min-w-0 flex-[1_1_380px] flex-col gap-6 rounded-tile bg-gms-mist p-8">
          <div className="flex items-center gap-4">
            <span className="relative inline-flex h-[72px] w-[72px] flex-none rounded-full bg-gms-ink">
              <img
                src="/brand/guilherme-seguro.jpg"
                alt={info.founder}
                width={72}
                height={72}
                loading="lazy"
                decoding="async"
                className="h-full w-full rounded-full object-cover"
              />
              <span aria-hidden="true" className="absolute right-[2px] top-[2px] h-[14px] w-[14px] rounded-[3px] border-2 border-gms-mist bg-gms-accent" />
            </span>
            <div className="min-w-0">
              <div className="text-[20px] font-semibold tracking-[-0.02em]">{info.founder}</div>
              <div className="mt-[2px] text-[15px] text-gms-muted">{a.founderRole}</div>
            </div>
          </div>
          <dl className="flex flex-col">
            {a.facts.map(({ k, v }, i) => (
              <div
                key={k}
                className={`flex justify-between gap-4 border-t border-gms-line py-[14px] ${i === a.facts.length - 1 ? "border-b" : ""}`}
              >
                <dt className="font-mono text-[12.5px] text-gms-muted">{k}</dt>
                <dd className="text-right text-[15px] font-medium">{v}</dd>
              </div>
            ))}
          </dl>
          <a
            href={info.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="gms-btn mt-auto flex min-h-[56px] items-center justify-between gap-3 rounded-full bg-gms-ink px-[22px] text-[16px] font-semibold text-white no-underline hover:text-white"
          >
            {a.founderCta}
            <ArrowUpRight />
          </a>
        </aside>
      </div>
    </section>
  )
}
